import {
  SuggestedForYouWrapper,
  labelStyle,
  dividerStyle,
  customTabsSpacing,
} from "./styles";
import { People } from "../Tabs/People/People";
import { Organizations } from "../Tabs/Organizations/Organizations";
import { Tabs } from "../Tabs/Tabs";
import {
  useGetSuggestedQuery,
  useGetUsersQuery,
  useGetProfileQuery,
  useGetOrganizationsQuery,
} from "../../../redux/reducers/apiSlice";

const SUGGESTIONS_LIMIT = 5;

export const SuggestedForYou = () => {
  const {
    data: suggested,
    isLoading: loadingSuggested,
    isError,
  } = useGetSuggestedQuery(undefined, {
    maxRetries: 1,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
  });

  const { data: profile } = useGetProfileQuery();
  const currentUserId = profile?.id;

  const needPeopleFallback =
    !loadingSuggested &&
    suggested &&
    (suggested.users?.length ?? 0) === 0;
  const needOrgsFallback =
    !loadingSuggested &&
    suggested &&
    (suggested.organizations?.length ?? 0) === 0;

  const { data: allUsers = [], isLoading: loadingUsers } = useGetUsersQuery(
    undefined,
    { skip: !needPeopleFallback }
  );
  const { data: allOrgs = [], isLoading: loadingOrgs } =
    useGetOrganizationsQuery(undefined, { skip: !needOrgsFallback });

  const users =
    (suggested?.users?.length ?? 0) > 0
      ? suggested.users.slice(0, SUGGESTIONS_LIMIT)
      : (allUsers || [])
          .filter((u) => u.id !== currentUserId)
          .slice(0, SUGGESTIONS_LIMIT);
  const organizations =
    (suggested?.organizations?.length ?? 0) > 0
      ? suggested.organizations.slice(0, SUGGESTIONS_LIMIT)
      : (allOrgs || []).slice(0, SUGGESTIONS_LIMIT);

  const loading =
    loadingSuggested ||
    (needPeopleFallback && loadingUsers) ||
    (needOrgsFallback && loadingOrgs);

  return (
    <SuggestedForYouWrapper>
      <h2 data-cy="cypress-suggested-for-you-text">Suggested for you</h2>
      {isError && (
        <p style={{ padding: "8px 0", color: "#666", fontSize: "14px" }}>
          Unable to load suggestions. Please try again later.
        </p>
      )}
      <Tabs<"People" | "Organizations">
        customTabLabelStyle={labelStyle}
        customDividerStyle={dividerStyle}
        customTabsSpacing={customTabsSpacing}
        defaultSelectedTab={"People"}
        appendToUrl={true}
        tabs={[
          {
            label: "People",
            component: (
              <People
                loading={loading}
                people={users}
              />
            ),
          },
          {
            label: "Organizations",
            component: (
              <Organizations
                loading={loading}
                // @ts-ignore
                organizations={organizations}
              />
            ),
          },
        ]}
      />
    </SuggestedForYouWrapper>
  );
};
